import React, { useMemo } from 'react';

import { useIntl } from 'react-intl';

import { useStoreStatus } from './hooks';
import { StatusMessage } from './styled';
import { IStoreStatus } from './types';

export const StoreStatus = ({
  openingHours,
  closingHours,
  dayWeek,
  yesterdayClosingHours,
  yesterdayOpeningHours,
  dateNow,
}: IStoreStatus) => {
  const { formatMessage } = useIntl();
  const {
    getStoreStatus,
    parseStoreHourAsDate,
    formatMessageWithTime,
    colorState,
    hasInValidDayWeek,
  } = useStoreStatus({
    openingHours,
    closingHours,
    dayWeek,
    yesterdayClosingHours,
    yesterdayOpeningHours,
    dateNow,
  });

  const statusMessage = useMemo(() => {
    const openDate = parseStoreHourAsDate(openingHours);
    const storeStatus = getStoreStatus();
    const labelStatus = storeStatus ? formatMessage({ id: storeStatus }) : '';

    return formatMessageWithTime(storeStatus, labelStatus, openDate);
  }, [formatMessage, formatMessageWithTime, getStoreStatus, openingHours, parseStoreHourAsDate]);

  if (hasInValidDayWeek) {
    return null;
  }

  return <StatusMessage colorState={colorState}>{statusMessage}</StatusMessage>;
};
